var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBasket(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_50_2407)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.5 22.5C8.32843 22.5 9 21.8284 9 21C9 20.1716 8.32843 19.5 7.5 19.5C6.67157 19.5 6 20.1716 6 21C6 21.8284 6.67157 22.5 7.5 22.5Z",
    fill: "#5032C8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18 22.5C18.8284 22.5 19.5 21.8284 19.5 21C19.5 20.1716 18.8284 19.5 18 19.5C17.1716 19.5 16.5 20.1716 16.5 21C16.5 21.8284 17.1716 22.5 18 22.5Z",
    fill: "#5032C8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.5 16.4H6.69658L6.12258 13.6H19.4988C19.6949 13.6045 19.8865 13.5411 20.0411 13.4205C20.1961 13.2996 20.3044 13.1287 20.3476 12.937L20.3476 12.9367L21.8475 6.18703C21.876 6.06091 21.8754 5.92996 21.8456 5.80413C21.8158 5.67831 21.7578 5.56093 21.6758 5.46094C21.5938 5.36094 21.4902 5.28096 21.3726 5.22708C21.2555 5.17338 21.1276 5.14703 20.9988 5.15H4.44736L3.84815 2.08084L3.84815 2.08084L3.84798 2.08002C3.80825 1.88514 3.70142 1.71036 3.54611 1.58611C3.39107 1.46208 3.19751 1.39624 2.99902 1.4H0H-0.1V1.5V3V3.1H0H2.30294L5.15192 17.4195L5.15202 17.42C5.19176 17.6149 5.29858 17.7896 5.45389 17.9139C5.60892 18.0379 5.80246 18.1038 6.00094 18.1H19.5H19.6V18V16.5V16.4H19.5ZM19.9379 6.85L18.8197 11.9H5.79698L4.78698 6.85H19.9379Z",
    fill: "#5032C8",
    stroke: "#5032C8",
    strokeWidth: 0.2
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_50_2407"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBasket);
export default __webpack_public_path__ + "static/media/basket.ea741b199f10a6aeb5eb0d041a421703.svg";
export { ForwardRef as ReactComponent };